import { useQuery } from '@tanstack/react-query';
import { api, podatki } from '../api/odjemalec';
import { glave, obNapaki } from '../skrbnistvo/zeton';

/** Oznaka in barva stanja povratne informacije (NOVO / OGLEDANO / ZAKLJUCENO), enako pri stranki in v skrbništvu. */
export function statusPovratne(status: string | undefined): { naziv: string; barva: string } {
  switch (status) {
    case 'NOVO':
      return { naziv: 'novo', barva: 'red' };
    case 'ZAKLJUCENO':
      return { naziv: 'zaključeno', barva: 'green' };
    default:
      return { naziv: 'ogledano', barva: 'yellow' };
  }
}

/** »1 nov odgovor«, »2 nova odgovora«, »3 novi odgovori«, »5 novih odgovorov« (dvojina in množina). */
export function noviOdgovori(n: number): string {
  const d = n % 100;
  return d === 1
    ? `${n} nov odgovor`
    : d === 2
      ? `${n} nova odgovora`
      : d === 3 || d === 4
        ? `${n} novi odgovori`
        : `${n} novih odgovorov`;
}

/** »1 sporočilo«, »2 sporočili«, »3 sporočila«, »5 sporočil«. */
export function sporocil(n: number): string {
  const d = n % 100;
  return `${n} ${d === 1 ? 'sporočilo' : d === 2 ? 'sporočili' : d === 3 || d === 4 ? 'sporočila' : 'sporočil'}`;
}

/** Število niti z neprebranim odgovorom (oznaka na začetnem zaslonu), osveženo vsakih 5 minut in ob vrnitvi na zavihek. */
export function useNeprebraniOdgovori() {
  return useQuery({
    queryKey: ['povratne-stevilo'],
    queryFn: ({ signal }) => podatki(api.GET('/api/povratne-informacije/stevilo', { signal })),
    refetchInterval: 300_000,
    refetchOnWindowFocus: true,
  });
}

/** Skrbništvo: število povratnih informacij v stanju NOVO (oznaka na zavihku), osveženo vsaki 2 minuti. */
export function useNovePovratne() {
  return useQuery({
    queryKey: ['skrbnik', 'povratne-stevilo'],
    queryFn: async ({ signal }) => {
      try {
        return await podatki(api.GET('/api/skrbnik/povratne-informacije/stevilo', { signal, headers: glave() }));
      } catch (e) {
        obNapaki(e);
        throw e;
      }
    },
    refetchInterval: 120_000,
  });
}
